<template>
	<b-card no-body>
		<b-card-header>
			<div>
				<b-card-title class="mb-25">Chatwoot — chat support clients finaux (30j)</b-card-title>
				<b-card-text class="mb-0">
					Données live via Chatwoot Platform API · fenêtre 30 derniers jours
				</b-card-text>
			</div>
		</b-card-header>
		<b-card-body>
			<div v-if="loading" class="text-center text-muted py-2">
				<b-spinner small variant="primary" /> Appel Chatwoot en cours…
			</div>
			<b-alert v-else-if="!available" show variant="info" class="mb-0">
				<feather-icon icon="InfoIcon" />
				Stats Chatwoot indisponibles ({{ unavailableReason }}).
			</b-alert>
			<div v-else-if="centresCount === 0" class="text-muted">
				Aucun centre Chatwoot provisionné dans le périmètre sélectionné.
			</div>
			<div v-else>
				<b-row class="match-height mb-1">
					<b-col md="3">
						<b-card no-body class="text-center">
							<b-card-body>
								<h3 class="mb-25">{{ formatNb(totals.conversations_count) }}</h3>
								<small class="text-muted">Conversations</small>
							</b-card-body>
						</b-card>
					</b-col>
					<b-col md="3">
						<b-card no-body class="text-center">
							<b-card-body>
								<h3 class="mb-25">{{ formatNb(totals.incoming_messages_count) }}</h3>
								<small class="text-muted">Messages clients</small>
							</b-card-body>
						</b-card>
					</b-col>
					<b-col md="3">
						<b-card no-body class="text-center">
							<b-card-body>
								<h3 class="mb-25">{{ formatNb(totals.outgoing_messages_count) }}</h3>
								<small class="text-muted">Réponses centres</small>
							</b-card-body>
						</b-card>
					</b-col>
					<b-col md="3">
						<b-card no-body class="text-center">
							<b-card-body>
								<h3 class="mb-25">{{ formatNb(totals.resolutions_count) }}</h3>
								<small class="text-muted">Résolutions</small>
							</b-card-body>
						</b-card>
					</b-col>
				</b-row>
				<div class="text-muted small mb-1">
					Centres interrogés : <strong>{{ centresOk }} / {{ centresCount }}</strong>
					<span v-if="errors.length"> · {{ errors.length }} en erreur</span>
				</div>
				<b-table-simple v-if="perCenter.length" small striped responsive class="mb-0">
					<b-thead>
						<b-tr>
							<b-th>Centre</b-th>
							<b-th class="text-right">Conversations</b-th>
							<b-th class="text-right">Msgs reçus</b-th>
							<b-th class="text-right">Msgs envoyés</b-th>
							<b-th class="text-right">Résolus</b-th>
						</b-tr>
					</b-thead>
					<b-tbody>
						<b-tr v-for="c in perCenter" :key="c.C_UI">
							<b-td>{{ c.C_libelle }}</b-td>
							<b-td class="text-right">{{ formatNb(c.conversations_count) }}</b-td>
							<b-td class="text-right">{{ formatNb(c.incoming_messages_count) }}</b-td>
							<b-td class="text-right">{{ formatNb(c.outgoing_messages_count) }}</b-td>
							<b-td class="text-right">{{ formatNb(c.resolutions_count) }}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
				<div v-if="errors.length" class="mt-2">
					<b-alert show variant="warning" class="mb-0 py-1 px-2">
						<small>
							Centres en erreur :
							<span v-for="(e, idx) in errors" :key="idx">
								<code>{{ e.C_libelle || e.C_UI }}</code>
								<span class="text-muted">({{ e.reason }})</span><span v-if="idx < errors.length - 1">, </span>
							</span>
						</small>
					</b-alert>
				</div>
			</div>
		</b-card-body>
	</b-card>
</template>

<script>
import {
	BRow, BCol, BCard, BCardHeader, BCardTitle, BCardBody, BCardText, BSpinner, BAlert,
	BTableSimple, BThead, BTbody, BTr, BTh, BTd,
} from 'bootstrap-vue'

export default {
	components: {
		BRow,
		BCol,
		BCard,
		BCardHeader,
		BCardTitle,
		BCardBody,
		BCardText,
		BSpinner,
		BAlert,
		BTableSimple,
		BThead,
		BTbody,
		BTr,
		BTh,
		BTd,
	},
	props: {
		cuis: { type: String, default: '' },
	},
	data() {
		return {
			loading: false,
			available: true,
			unavailableReason: '',
			centresCount: 0,
			centresOk: 0,
			totals: { conversations_count: 0, incoming_messages_count: 0, outgoing_messages_count: 0, resolutions_count: 0 },
			perCenter: [],
			errors: [],
		}
	},
	created() { this.load() },
	methods: {
		formatNb(n) { return (n || 0).toLocaleString('fr-FR') },
		load() {
			this.loading = true
			const url = `/admin/stats-clients/chatwoot${this.cuis ? `?CUIS=${encodeURIComponent(this.cuis)}` : ''}`
			this.$http.get(url)
				.then(response => {
					this.loading = false
					const d = response.data || {}
					if (d.res === 1) {
						if (d.available === false) {
							this.available = false
							this.unavailableReason = d.reason || 'unknown'
							return
						}
						this.available = true
						this.centresCount = d.centres_count || 0
						this.centresOk = d.centres_ok || 0
						this.totals = d.totals || this.totals
						this.perCenter = d.per_center || []
						this.errors = d.errors || []
					}
				})
				.catch(() => {
					this.loading = false
					this.available = false
					this.unavailableReason = 'network_error'
				})
		},
	},
}
</script>
